import { RouteType } from '@Pages/RetroSynthesis/constants';

// RPS compound indicator - type PREDICTED (RETROSYNTHESIS) and has reaction data
export function isItemRPSCompound(item) {
  return item?.type === RouteType.PREDICTED && !!item?.reaction;
}

// RPS - update link data if item is RPS compound
// updateItemRPSCompound returns only { type, reaction: { reactionId, databaseId } } OR empty object
// Must use spread to merge into existing item data
export function updateItemRPSCompound(item) {
  const { reaction } = item;

  return {
    type: RouteType.PUBLISHED,
    reaction,
  };
}

// RPS - update group data if item is RPS compound
// updateGroupRPSCompound returns only { type, reactionId, databaseId } OR empty object
// Must use spread to merge into existing item data
export function updateGroupRPSCompound(group, routeLayout) {
  const { id: groupId, type: groupType } = group;
  const childItem = routeLayout.find((child) => child.group === groupId);
  return childItem && childItem.type !== groupType
    ? {
        type: childItem.type,
        ...childItem?.reaction,
      }
    : {};
}
